import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor() {}

  /**
   * Returns the student's id from the student string
   * @param studentStr Student string. Ex. John Doe (970123456) or (970123456) for demo users
   * @returns Uwf id. Ex. 970123456
   */
  getStudentIdFromNameAndIdString(studentStr: string): number {
    return Number(studentStr.split(' ').at(-1)!.slice(1, -1));
  }
}
